import { parseAsArrayOf, parseAsStringEnum, useQueryState } from "nuqs";

export const useSearchByQueryState = <T extends string>(
  searchBy: Array<T> | Record<string, T>,
) => {
  return useQueryState<T[]>(
    "searchBy",
    parseAsArrayOf(
      parseAsStringEnum<T>(
        Array.isArray(searchBy) ? searchBy : Object.values(searchBy),
      ),
    ),
  );
};
